import { VALID_PATH_SEGMENTS, PDP_MVT_PATH_SEGMENTS } from "./constants";

const validPath = (pathsToCheck = VALID_PATH_SEGMENTS) =>
  !!window.location.pathname
    .split("/")
    .find(pathSegment => pathsToCheck.find(path => !pathSegment.indexOf(path)));

export const bagCheckoutMVTPath = () => validPath(PDP_MVT_PATH_SEGMENTS);

export default validPath;
